import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-becas-detalle-operario',
  templateUrl: './becas-detalle-operario.component.html',
  styleUrls: ['./becas-detalle-operario.component.css']
})
export class BecasDetalleOperarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecBecas = [];
  public vecAddBecas = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarBecas();
  }
  //FUNCION QUE CARGA TODOS LOS DETALLES DE BECAS REGISTRADOS
  async cargarBecas() {
    this.cargando.abrir();
    this.vecBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.becas) {
        this.vecBecas.push({
          idBeca: res.becas[i]['intIdBecas'], nombre: res.becas[i]['strNombre'], detalle: res.becas[i]['strDescripcion'],
          estado: res.becas[i]['intEstado'] == 1 ? "Activo" : "Inactivo",
          etiqueta: res.becas[i]['intEstado'] == 1 ? "Desactivar" : "Activar"
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVA BECA
  async modalNuevaBeca(nameMod) {
    if (localStorage.getItem('insUser') == 'true') {
      this.tituloModal = "Ingresar un detalle de beca"; this.accion = 1;
      this.borrarDatos();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR LOS DETALLES DE LAS BECAS
  modalModBecas(nameMod, objRol) {
    if (localStorage.getItem('modUser') == 'true') {
      this.tituloModal = "Modificar el detalle de la beca"; this.accion = 2;
      this.buscarDetalleBeca(objRol);
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE PERMITE AGREGAR O EDITAR UN DETALLE DE BECA
  agregarBeca() {
    this.srvInsert.ingresoGestionBecas(this.vecAddBecas[0]['idBeca'], this.vecAddBecas[0]['nombre'], this.vecAddBecas[0]['detalle'], this.vecAddBecas[0]['estado'],
      'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', this.accion).subscribe(res => {
        if (res.becas) {
          if (this.accion == 1)
            this.buscarIdTipoBecas(this.vecAddBecas[0]['nombre'], 2);
          else
            this.agregarModulo(this.vecAddBecas[0]['nombre'], this.vecAddBecas[0]['estado'], this.vecAddBecas[0]['idBeca'], 7);
          this.alerti.success('Beca registrada correctamente');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarBecas();
        }
        else
          this.alerti.error("No se pudo registrar la información.");
      });
  }
  //FUNCION PARA MODIFICAR EL ESTADO DE UN DETALLE DE BECA
  cambiarEstado(beca) {
    if (localStorage.getItem('modUser') == 'true') {
      this.srvInsert.ingresoGestionBecas(beca['idBeca'], beca['estado'] == "Activo" ? 2 : 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 3).subscribe(res => {
        if (res.becas) {
          this.agregarModulo("na", beca['estado'] == "Activo" ? 2 : 1, beca['idBeca'], 8)
          this.alerti.success('Estado editado correctamente');
          this.reiniciarTabla();
          this.cargarBecas();
        }
        else
          this.alerti.error("No actualizar el estado.");
      });
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }

  //FUNCION QUE BUSCA EL ID DEL TIPO DE BECA
  async buscarIdTipoBecas(nombre, opc) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(9, nombre, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.agregarModulo(nombre, res.becas[0]['intEstado'], res.becas[0]['idBeca'], opc);
    }
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS MODULOS DEL SISTEMA REGISTRADOS
  agregarModulo(nombre, estado, codigo, opcion) {
    this.srvInsert.ingresoGestionPermisos("na", nombre, estado, 'icono', codigo, 2, "na", "na", "na", "na", opcion).subscribe(res => {
      if (!res.permiso)
        this.alerti.error("No se puede agregar la actividad");
    });
  }

  //FUNCION PARA MOSTRAR LOS DATOS DEL DETALLE DE LA BECA SELECCIONASO
  async buscarDetalleBeca(datoRol) {
    this.cargando.abrir();
    this.vecAddBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(2, datoRol['idBeca'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddBecas.push({
        idBeca: res.becas[0]['intIdBecas'], nombre: res.becas[0]['strNombre'], detalle: res.becas[0]['strDescripcion'],
        estado: res.becas[0]['intEstado']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //INSTANCIAR LAS VARIABLES 
  borrarDatos() {
    this.vecAddBecas = [];
    this.vecAddBecas.push({
      idBeca: 0, nombre: "", detalle: "", estado: 1
    });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
